import './scss/app.scss';

import FormValidator from './js/form-validation.js';
import FileUploadManager from './js/file-upload.js';
import JobListFilter from './js/job-list-filter.js';
import JobDetail from './js/job-header-slider.js';

import Choices from 'choices.js';

document.addEventListener("DOMContentLoaded", () => {
  const choiceElements = document.querySelectorAll('.filter-select');
  for (const element of choiceElements) {
    let choices = new Choices(element, {
      itemSelectText: ''
    });
  }

  const filter = new JobListFilter();

  const formValidator = new FormValidator('#applicationForm');

  const fileUpload = new FileUploadManager('#fileUpload', {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/*', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    maxFiles: 10,
    onFilesAdded: (files) => {
      console.log('Files added a:', files);
    }
  });

  const cvUpload = new FileUploadManager('#cvUpload', {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/*', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    maxFiles: 10,
    onFilesAdded: (files) => {
      console.log('Files added a:', files);
    }
  });
});
